module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container details mb-4 p-sm-3 col-md-8"
  }, [_c('h1', {
    staticClass: "lead d-inline-block mr-2"
  }, [_vm._v("撮影会／イベント／教室 詳細")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-new text-white",
    attrs: {
      "to": "/list"
    }
  }, [_vm._v("一覧ページへ")]), _vm._v(" "), (_vm.isApply) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('a', {
    staticClass: "btn btn-warning text-white",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.remand($event)
      }
    },
    slot: "footer"
  }, [_vm._v("承認依頼取消")]), _vm._v(" "), _c('div', [_vm._v("※このイベントは事務局へ承認申請中のため、編集する場合は「承認依頼取消」ボタンを押して事務局への承認依頼を取り消して下さい。")])]) : _vm._e(), _vm._v(" "), _c(_vm.container, {
    tag: "div",
    attrs: {
      "item": _vm.eventDetail
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-new text-white",
    attrs: {
      "to": "/list",
      "title": ""
    }
  }, [_vm._v("一覧ページへ")]), _vm._v(" "), _c('p', {
    staticClass: "text-right mt-5"
  }, [_c('router-link', {
    attrs: {
      "to": "/mypage"
    }
  }, [_vm._v("マイページへのリンク")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cf1c6812!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/event/Details.vue
// module id = 359
// module chunks = 1